import { jsonProperty, Serializable } from "ts-serializable";

class Role extends Serializable{

    @jsonProperty(String, null)
    id: string | null = null;

    @jsonProperty(String, null)
    nome: string | null = null;

    @jsonProperty(String, null)
    codigo: string | null = null;

    @jsonProperty(String, null)
    descricao: string | null = null;

    @jsonProperty(Boolean, null)
    atribuivel: boolean | null = null;

    @jsonProperty(Boolean, null)
    profissionalSaude: boolean | null = null;
}  

export default Role;